import DOMPurify from 'dompurify'
import { marked } from 'marked'

const ALLOWED_TAGS = [
  'a',
  'blockquote',
  'br',
  'code',
  'del',
  'em',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'hr',
  'li',
  'ol',
  'p',
  'pre',
  'strong',
  'table',
  'tbody',
  'td',
  'th',
  'thead',
  'tr',
  'ul',
]

const ALLOWED_ATTR = ['href', 'rel', 'target']

function enforceSafeLinks(container) {
  container.querySelectorAll('a[href]').forEach((link) => {
    const href = link.getAttribute('href') || ''
    try {
      const url = new URL(href, window.location.origin)
      if (!['http:', 'https:', 'mailto:'].includes(url.protocol)) {
        link.removeAttribute('href')
      }
    } catch {
      link.removeAttribute('href')
    }
    link.setAttribute('rel', 'noopener noreferrer')
    link.setAttribute('target', '_blank')
  })
}

export function sanitizeHtml(html) {
  return DOMPurify.sanitize(String(html || ''), {
    ALLOWED_ATTR,
    ALLOWED_TAGS,
    FORBID_ATTR: ['style', 'onerror', 'onload'],
    FORBID_TAGS: ['iframe', 'object', 'embed', 'script', 'style', 'svg', 'math'],
    RETURN_DOM_FRAGMENT: false,
  })
}

export function markdownToSafeHtml(markdown) {
  const rawHtml = marked.parse(String(markdown || ''), {
    breaks: true,
    gfm: true,
  })
  const sanitized = sanitizeHtml(rawHtml)
  if (typeof document === 'undefined') return sanitized
  const template = document.createElement('template')
  template.innerHTML = sanitized
  enforceSafeLinks(template.content)
  return template.innerHTML
}
